module.exports = "/assets/images/history_a5e49f.svg";